import axiosInstance from './axios'
import { AxiosResponse } from 'axios'

export interface RelationshipNode {
    id: string
    entity: string
    value?: string
}

export interface RelationshipEdge {
    origin: string
    relationship: string
    destination: string
}

export interface RelationshipsData {
    nodes: RelationshipNode[]
    edges: RelationshipEdge[]
}

class RelationshipsService {
    constructor(private apiVersion: string = 'v1') {}

    public async getRelationships(cpfs: string, cnpjs: string): Promise<RelationshipsData> {
        const params: Record<string, string> = {}
        if (cpfs) params.cpfs = cpfs
        if (cnpjs) params.cnpjs = cnpjs
        return axiosInstance.get(`${this.apiVersion}/relationships`, { params })
            .then((response: AxiosResponse) => response.data)
            .catch((err: any) => {
                throw new Error(err.message)
            })
    }
}

const relationshipsService: RelationshipsService = new RelationshipsService()

export default relationshipsService
